import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { ValueType } from 'react-select';
import { makeStyles, useTheme, darken } from '@material-ui/core/styles';

import { Translate } from '@hydra/common/components';
import { sendEvent } from '@hydra/utils/gtm';
import { useI18n } from '@hydra/common/customHooks';

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: theme.typography.fontSizeLarge,
    fontWeight: theme.typography.fontWeightSemibold,
    marginBottom: theme.spacing(0.75)
  }
}));

interface SelectTagsProps {
  projectTags: string[]
  selectTags: (tags: string[]) => void
  tags: string[]
  createOption: (label: string) => {
    label: string;
    value: string;
  }
}

export default function SelectTags ({ projectTags, selectTags, tags, createOption }: SelectTagsProps) {
  const theme = useTheme();
  const classes = useStyles();
  const { translate } = useI18n();

  const handleChange = (currentTags: ValueType<{
    label: string;
    value: string;
  }, true>) => {
    if (currentTags && currentTags.length === 0) {
      sendEvent('keywordtool-addkeyword-tagscleared-btn');
    } else if (currentTags && currentTags.length > tags.length) {
      sendEvent('keywordtool-addkeyword-tagadded-label');
    } else {
      sendEvent('keywordtool-addkeyword-tagremoved-label');
    }
    selectTags(currentTags ? currentTags.map(({ value }) => value) : []);
  };

  const tagSelectStyles = () => ({
    multiValue: (base: any) => ({
      ...base,
      borderRadius: theme.shape.borderRadius * 6,
      backgroundColor: theme.palette.grey[200],
      color: darken(theme.palette.grey[900], 0.3)
    }),
    multiValueLabel: (base: any) => ({
      ...base,
      borderRadius: theme.shape.borderRadius * 6,
      backgroundColor: theme.palette.grey[200],
      color: darken(theme.palette.grey[900], 0.3)
    }),
    multiValueRemove: (base: any) => ({
      ...base,
      borderRadius: theme.shape.borderRadius * 6,
      backgroundColor: theme.palette.grey[200],
      color: darken(theme.palette.grey[900], 0.3),
      cursor: 'pointer',
      '&:hover': {
        color: darken(theme.palette.grey[900], 0.3),
        backgroundColor: theme.palette.grey[300]
      }
    })
  });

  return (
    <>
      <Translate component='div' content='serp_add_modal_tags_title' className={classes.title} />
      <CreatableSelect
        onChange={handleChange}
        placeholder=''
        isClearable
        isMulti
        styles={tagSelectStyles()}
        options={projectTags.map(tag => createOption(tag))}
        noOptionsMessage={() => projectTags && projectTags.length > 0 ? translate('serp_add_modal_no_more_tags') : translate('serp_add_modal_no_tags')}
        formatCreateLabel={(tag) => translate('serp_add_modal_create_tag', { with: { tag } })}
      />
    </>
  );
}
